import { Board } from './components/Board';

export default function App() {
	return (
		<div className="w-full h-full">
			<Board />
		</div>
	);
}
